import { render, staticRenderFns } from "./HeaderLanding.vue?vue&type=template&id=47308e94&"
import script from "./HeaderLanding.vue?vue&type=script&lang=js&"
export * from "./HeaderLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports